<template>
  <div>
    <v-card-text>
      <v-row>
        <v-text-field v-model="search" label="Search" solo></v-text-field>
      </v-row>
    </v-card-text>

    <v-row>
      <v-col class="justify-end">
        <!-- <v-btn @click="print">Download Katalog (PNG)</v-btn> -->
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="black" class="white--text" dark v-bind="attrs" v-on="on">
              Download Katalog
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="print">
              <v-list-item-title>Download PDF</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item @click="generataPNG">
              <v-list-item-title>Download PNG</v-list-item-title>
            </v-list-item> -->
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <v-overlay :value="overlay"></v-overlay>
    <template v-if="listData.length > 0">
      <vue-custom-scrollbar class="scroll-area " :settings="settings">
        <v-row
          :class="{ printing: overlay }"
          ref="downloadImage"
          id="section-to-print"
          v-if="!loading"
        >
          <template v-for="(item, idx) in filteredItems">
            <template>
              <v-col
                :class="overlay ? 'col-3' : 'col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3'"
                :key="idx"
              >
                <card :item="item" @showConfirmAdd="showConfirmAdd">
                  <div style="display: flex; flex-wrap: wrap">
                    <v-chip-group column class="text-center">
                      <tooltip-chip color="#65c5fe" content="Harga Starter">
                        {{ calcPrice(item.product_price, item.discount_percent_reseller_starter) }}
                      </tooltip-chip>
                      <tooltip-chip color="#f0c131" content="Harga Bisnis">
                        {{ calcPrice(item.product_price, item.discount_percent_reseller_bisnis) }}
                      </tooltip-chip>
                      <tooltip-chip color="#9231fd" content="Harga Enterprise">
                        {{
                          calcPrice(item.product_price, item.discount_percent_reseller_enterprise)
                        }}
                      </tooltip-chip>
                    </v-chip-group>
                  </div>
                </card>
              </v-col>
              <div class="page-break" :key="item.product_id" v-if="idx !== 0 && idx % 6 == 0"></div>
            </template>
          </template>
        </v-row>
        <v-row v-else>
          <v-col class="text-center">
            <v-progress-circular indeterminate color="green"></v-progress-circular>
          </v-col>
        </v-row>
      </vue-custom-scrollbar>
    </template>

    <v-row v-else>
      <v-card>
        <v-card-text>
          Data Tidak Tersedia
        </v-card-text>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import card from "./card.vue";
import { toPng } from "html-to-image";
import html2pdf from "html2pdf.js";
import tooltipChipVue from "./tooltipChip.vue";
import jsPDF from "jspdf";
export default {
  components: {
    "tooltip-chip": tooltipChipVue,
    card,
    vueCustomScrollbar
  },
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    loading: Boolean
  },
  watch: {
    listData(nv) {
      this.search = "";
    }
  },
  computed: {
    filteredItems() {
      const lowerSearch = this.search.toLowerCase();
      return this.listData.filter(item => item.product_name.toLowerCase().includes(lowerSearch));
    }
  },
  data() {
    return {
      selectedItem: {},
      overlay: false,
      search: "",
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false
      }
    };
  },
  methods: {
    print() {
      let width = 600,
        height = 600,
        left = (screen.width - width) / 2,
        top = 0,
        disp_setting = "toolbar=no,location=no,";

      disp_setting += "directories=no,menubar=no,";
      disp_setting +=
        "scrollbars=yes,width=" + width + ", height=" + height + ", left=" + left + ", top=" + top;
      let style = `  .card-footer { 
  display: flex;
  justify-content: start;
  align-items: center;
}
.title-product { 
  background: rgb(255, 241, 110);
  background: linear-gradient(
    90deg,
    rgba(255, 241, 110, 1) 25%,
    rgba(213, 164, 31, 1) 100%
  );
  font-size: 1rem;
  font-weight: 700;
  color: #000;
  border-radius: 15px;
  margin: 0 .5rem;
  padding:.5rem;
  text-align: center;
}
.card-product {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  // margin: 16px;
  width: 100%;
  height: 100%;
  transition: transform 0.2s ease-in-out;
} 

.card-product-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.card-product-content {
  padding: 16px;
}

.card-product-title {
  font-size: 1.2rem;
  margin-bottom: 8px;
}

.card-product-description {
  color: #555;
  margin-bottom: 12px;
}

.card-product-price {
  font-weight: bold;
  color: #333;
}
 .row{
  display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    margin-right: -12px;
    // margin-left: -12px;
}
.v-chip { 
  background:unset !important;
}
.v-chip-group .v-chip {
    margin: 4px 8px 4px 0;
}
.col-3{
  -webkit-box-flex: 0;
    -ms-flex: 0 0 33.3333333333%;
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%; 
}body{-webkit-print-color-adjust: exact;}
button {visibility: hidden;}
      `;
      this.overlay = true;
      setTimeout(() => {
        let content_vlue = document.getElementById("section-to-print").innerHTML;
        let docprint = window.open("", "", disp_setting);
        docprint.document.open();
        docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
        docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
        docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
        docprint.document.write("<head><title>Print</title>");
        docprint.document.write('<style type="text/css">body{ margin:.5rem;');
        docprint.document.write("font-family:Verdana, Geneva, sans-serif; font-size:12px;}");
        docprint.document.write(style);
        docprint.document.write(
          "@media print {	@page {margin: 0 .5rem 0 0 ;	size:letter;}  body{-webkit-print-color-adjust: exact;} .page-break { page-break-before: always; } }"
        );
        docprint.document.write("a{color:#000;text-decoration:none;} </style>");
        docprint.document.write(
          '</head><body onLoad="self.print()" onafterprint="window.close()"><div class="row">'
        );
        docprint.document.write(content_vlue);
        docprint.document.write("</div></body></html>");
        docprint.document.close();
        docprint.focus();

        this.overlay = false;
      }, 100);
    },
    generataPNG() {
      this.overlay = true;
      setTimeout(() => {
        const pdfContent = this.$refs.downloadImage;
        const now = new Date();
        const unixTime = Math.floor(now.getTime() / 1000);
        if (pdfContent === null) {
          return;
        }
        // Konversi elemen HTML menjadi gambar (PNG)

        toPng(pdfContent, { backgroundColor: "#f7f7f7" })
          .then(dataUrl => {
            const link = document.createElement("a");
            link.download = `Katalog-${unixTime}.png`;
            link.href = dataUrl;
            link.click();
            console.log("load");
            this.overlay = false;
          })
          .catch(err => {
            this.overlay = false;
            console.log(err);
          });
      }, 500);
    },
    saveOrShowPDF(pdf) {
      // Simpan PDF atau tampilkan preview
      // Misalnya, simpan sebagai file
      pdf.save("output.pdf");

      // Atau tampilkan preview dalam iframe
      // const blob = pdf.output('blob');
      // const objectUrl = URL.createObjectURL(blob);
      // window.open(objectUrl, '_blank');
    },
    printPDF() {
      const content = this.$refs.downloadImage; // Replace with the appropriate selector
      console.log("print");
      // Options for html2pdf
      const options = {
        margin: 10,
        filename: "document.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
      };

      html2pdf()
        .from(content)
        .set(options)
        .outputPdf(pdf => {
          const blob = new Blob([pdf], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = options.filename;
          link.click();
        });
    },
    async downloadPNG() {
      const el = this.$refs.downloadImage;
      const now = new Date();
      const unixTime = Math.floor(now.getTime() / 1000);

      if (el === null) {
        return;
      }

      //   this.isLoadingImage = true;

      await toPng(el, { backgroundColor: "#f7f7f7", skipFonts: true })
        .then(dataUrl => {
          const link = document.createElement("a");
          link.download = `Katalog-${unixTime}.png`;
          link.href = dataUrl;
          link.click();
          console.log("load");
        })
        .catch(err => {
          console.log(err);
        });

      //   this.isLoadingImage = false;
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    calcPrice(price, percent) {
      let val = Number(price) * (Number(percent) / 100);
      return (Number(price) - val).toLocaleString("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0
      });
    },
    showConfirmAdd(item) {
      this.$emit("showConfirmAdd", item);
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll-area {
  position: relative;
  margin-top: 0;
  height: 100dvh;
}
.printing {
  width: 297mm !important;
}
</style>
